export const AI_ENGINEERING_MODULE_OPTIONS = [
  { value: 'inventory', label: 'Inventário' },
  { value: 'sales', label: 'Vendas' },
  { value: 'services', label: 'Serviços' },
  { value: 'procurement', label: 'Compras' },
  { value: 'cash', label: 'Caixa' },
  { value: 'reports', label: 'Relatórios' },
  { value: 'settings', label: 'Definições' },
  { value: 'auth', label: 'Autenticação' },
  { value: 'frontend_shared', label: 'Frontend Shared' },
  { value: 'backend_shared', label: 'Backend Shared' },
  { value: 'cross_module', label: 'Cross Module' },
];

export const AI_ENGINEERING_RISK_OPTIONS = [
  { value: 'low', label: 'Baixo' },
  { value: 'medium', label: 'Médio' },
  { value: 'high', label: 'Alto' },
];

export const AI_ENGINEERING_REJECTABLE_STATUSES = ['draft', 'analyzed', 'patch_generated', 'tests_passed', 'tests_failed'];

const STATUS_LABELS = {
  draft: 'Draft',
  analyzed: 'Analyzed',
  patch_generated: 'Patch Generated',
  tests_passed: 'Tests Passed',
  tests_failed: 'Tests Failed',
  approved: 'Approved',
  rejected: 'Rejected',
};

const STATUS_TONES = {
  draft: 'border-slate-300 bg-slate-100 text-slate-700',
  analyzed: 'border-blue-200 bg-blue-50 text-blue-700',
  patch_generated: 'border-amber-200 bg-amber-50 text-amber-700',
  tests_passed: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  tests_failed: 'border-red-200 bg-red-50 text-red-700',
  approved: 'border-slate-900 bg-slate-900 text-white',
  rejected: 'border-red-300 bg-red-100 text-red-800',
};

const RISK_TONES = {
  low: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  medium: 'border-amber-200 bg-amber-50 text-amber-700',
  high: 'border-red-200 bg-red-50 text-red-700',
};

const ACTION_LABELS = {
  create: 'Pedido criado',
  analyze: 'Analyze Real',
  analyze_failed: 'Analyze Real falhou',
  generate_patch: 'Suggest Fix Real',
  generate_patch_failed: 'Suggest Fix Real falhou',
  run_tests: 'Testes mockados',
  approve: 'Aprovação interna',
  reject: 'Rejeição interna',
  open_pr: 'Open PR mock',
};

export const getAIEngineeringStatusLabel = (status) => STATUS_LABELS[status] || status || 'Sem estado';
export const getAIEngineeringStatusTone = (status) => STATUS_TONES[status] || STATUS_TONES.draft;
export const getAIEngineeringRiskTone = (risk) => RISK_TONES[risk] || RISK_TONES.medium;
export const getAIEngineeringActionLabel = (action) => ACTION_LABELS[action] || action || 'Acção';
export const getAIEngineeringModuleLabel = (moduleKey) => AI_ENGINEERING_MODULE_OPTIONS.find((item) => item.value === moduleKey)?.label || moduleKey || 'Módulo';
export const getAIEngineeringRiskLabel = (risk) => AI_ENGINEERING_RISK_OPTIONS.find((item) => item.value === risk)?.label || risk || 'Médio';